<section>
    <div class="container">
      <div class="row text-center align-items-end">
        <!-- Package-->
        <div class="col-lg-6 mb-5 mb-lg-0 mx-auto">
          <div class="p-5 rounded-lg shadow border border-primary price-category">
            <h1 class="h6 text-uppercase font-weight-bold mb-4">Please standby!</h1>
            <h2 class="h1 font-weight-bold">Redirecting...</h2>
  
            <div class="custom-separator my-4 mx-auto bg-primary"></div>
            <div class="loading-section mx-auto">
               <p class="text-center">{{ (statusMessage$ | async) }}</p>
            </div>
            <button (click)="refresh()" class="btn btn-block p-2 shadow" 
              [ngClass]="{
                'btn-secondary': !(loadError$ | async),
                'btn-primary': (loadError$ | async)
              }">Refresh</button>
          </div>
        </div>
      </div>
    </div>
  </section>
  